<template>
  <div class="jr-dialog">
    <div v-if="showMaxMin">
      <el-dialog
        :title="title"
        :visible.sync="isShow"
        :before-close="closeDialog"
        :width="width"
        :height="height"
         v-dialogDrag = "defaultMaxScreen"
        :close-on-click-modal="false"
        :modal="modal"
      >
        <div class="realheight" :style="{height:height}">
          <slot></slot>
        </div>
      </el-dialog>
    </div>
    <div v-if="!showMaxMin">
      <el-dialog
        :title="title"
        :visible.sync="isShow"
        :before-close="closeDialog"
        :width="width"
        :height="height"
        :close-on-click-modal="false"
        :modal="modal"
      >
        <div :style="{height:height}">
          <slot></slot>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'jr-dialog',
    props:{
      isShow: {
        type: Boolean,
        default: true
      },
      modal: {
        type: Boolean,
        default: false
      },
      showMaxMin: {
        type: Boolean,
        default: true
      },
      defaultMaxScreen: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: '标题'
      },
      width: {
        type: String,
        default: "50%"
      },
      height: {
        type: String,
        default: "500px"
      },

    },
    data() {
      return {
      };
    },
    methods:{
      closeDialog(){
        this.$emit('closeDialog');
      }
    }
  };
</script>

<style>
  .el-dialog{
    margin: 0 auto;
    overflow: hidden;
    /* margin-top: 0px !important; */
  }
  .jr-dialog .el-dialog__body{
    height:100%;
    padding: 0px 10px 10px 10px;
  }
  .jr-dialog .el-dialog__headerbtn{
    top:10px;
  }
  .jr-dialog .el-dialog__header{
    padding: 10px 10px 10px 10px;
    min-height: 24px;
  }

  .jr-dialog .jr-form{
    padding: 0px 0px 0px 0px;
  }
  .jr-dialog .el-dialog{
    /*position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    margin-top: 0px!important;*/
    box-shadow: 1px 1px 5px 1px rgb(0 0 0 / 30%);

  }
</style>



// WEBPACK FOOTER //
// src/common/dialog/dialog.vue